import React from 'react';
import { useSettings } from '../../context/SettingsContext';
import { money } from '../../utils/format';

export default function Price({ price, compareAtPrice, className = '', large = false }) {
  const { settings } = useSettings();
  const symbol = settings.shop?.currencySymbol || '$';
  const onSale = compareAtPrice && compareAtPrice > price;
  return (
    <div className={`product-prices ${onSale ? 'price--on-sale' : ''} ${className}`}>
      {onSale && <span className={`prod__compare_price mr-2 line-through text-color-secondary ${large ? 'text-lg' : ''}`}>{money(compareAtPrice, symbol)}</span>}
      <span className={`prod__price text-color-regular-price ${large ? 'text-2xl font-medium' : ''}`}>{money(price, symbol)}</span>
    </div>
  );
}
